import React from "react";
import OverlapSection from "../section/OverlapSection";
import imageSrc from "../../assets/images/adoption_image.png";

const Adoption = () => {
  return (
    <div className="toRight">
      <OverlapSection
        layoutClass="toRight"
        imageUrl={imageSrc}
        mainTitle="WHY BREED WHEN ADOPTING IS WAY EASIER"
        backText={"The pet you'll need has already taken birth in this world. \n Go for the one who is waiting day & night for a loving owner like you."}
        // buttonLink="/book"
      />
    </div>
  );
};

export default Adoption;
